import { Link, useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { formatINR } from "@/lib/api";
import { Trash2, Minus, Plus } from "lucide-react";

export default function Cart() {
  const { items, subtotal, setQty, remove } = useCart();
  const nav = useNavigate();

  return (
    <div className="fade-in max-w-[1200px] mx-auto px-6 md:px-12 py-16" data-testid="cart-page">
      <div className="font-micro text-[#8A8680] mb-4">Your Selection</div>
      <h1 className="font-serif text-[#EDE4D3] text-5xl mb-12">Cart</h1>

      {items.length === 0 ? (
        <div className="py-24 text-center">
          <div className="font-serif text-[#EDE4D3] text-3xl mb-4">The cart is empty.</div>
          <Link to="/" className="btn-bronze mt-6" data-testid="cart-continue-empty">Continue Browsing</Link>
        </div>
      ) : (
        <div className="grid md:grid-cols-[1.6fr_1fr] gap-16">
          <div>
            {items.map((it, idx) => (
              <div key={idx} className="flex gap-6 py-8" style={{ borderTop: "1px solid var(--hairline)" }} data-testid={`cart-item-${idx}`}>
                {it.image && <img src={it.image} alt="" className="w-32 h-40 object-cover" />}
                <div className="flex-1">
                  <div className="font-serif text-[#EDE4D3] text-xl">{it.name}</div>
                  <div className="font-micro text-[#8A8680] mt-2 space-y-1">
                    {Object.entries(it.customization || {}).map(([k, v]) => (
                      <div key={k}>{k}: <span className="text-[#D8D6D1]">{v}</span></div>
                    ))}
                  </div>
                  <div className="flex items-center gap-6 mt-5">
                    <div className="flex items-center gap-3" style={{ border: "1px solid var(--hairline)" }}>
                      <button onClick={() => setQty(idx, it.quantity - 1)} className="w-8 h-8 flex items-center justify-center text-[#EDE4D3]" data-testid={`cart-qty-dec-${idx}`}><Minus size={12} /></button>
                      <span className="text-[#EDE4D3] font-micro">{it.quantity}</span>
                      <button onClick={() => setQty(idx, it.quantity + 1)} className="w-8 h-8 flex items-center justify-center text-[#EDE4D3]" data-testid={`cart-qty-inc-${idx}`}><Plus size={12} /></button>
                    </div>
                    <button onClick={() => remove(idx)} className="text-[#8A8680] hover:text-[#B8895C] transition-colors" data-testid={`cart-remove-${idx}`}><Trash2 size={16} strokeWidth={1} /></button>
                  </div>
                </div>
                <div className="text-right">
                  <div className="font-serif text-[#EDE4D3] text-lg">{formatINR(it.unit_price * it.quantity)}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="md:sticky md:top-32 md:self-start p-8" style={{ background: "#141414", border: "1px solid var(--hairline)" }}>
            <div className="font-micro text-[#8A8680] mb-6">Summary</div>
            <div className="flex justify-between py-3 text-[#D8D6D1]"><span>Subtotal</span><span>{formatINR(subtotal)}</span></div>
            <div className="flex justify-between py-3 text-[#D8D6D1]"><span>Shipping</span><span className="font-micro">Calculated at checkout</span></div>
            <div className="flex justify-between py-4 mt-3" style={{ borderTop: "1px solid var(--hairline)" }}>
              <span className="font-serif text-[#EDE4D3] text-xl">Total</span>
              <span className="font-serif text-[#EDE4D3] text-xl" data-testid="cart-total">{formatINR(subtotal)}</span>
            </div>
            <button onClick={() => nav("/checkout")} className="btn-bronze w-full mt-6" data-testid="cart-checkout-btn">Proceed to Checkout</button>
          </div>
        </div>
      )}
    </div>
  );
}
